$ = require 'jquery'
track = require 'debug/track'
log = require 'debug/log'
Util = require 'lib/util'
ArchivedModelView = require 'views/archive/archived-model-view'
{ maybeDisplayLimitsErrorOnCardOpen } = require 'views/card/card-limits-error'
template = require 'views/templates/archive_item'

module.exports = class ArchivedListView extends ArchivedModelView

  reopen: (e) ->
    Util.preventDefault(e)

    hasAttachments = false
    @model.cardList.forEach (card) ->
      numAttachments = card.get('badges')?.attachments ? 0
      hasAttachments = hasAttachments || numAttachments > 0

    options = {
      $elem: $(e.target),
      hasAttachments: hasAttachments,
      destinationBoard: @model.getBoard(),
    }
    if maybeDisplayLimitsErrorOnCardOpen(options)
      return

    @model.update { closed: false }, (err) =>
      if err?
        @model.update { closed: true }
        track('List', "Reopen", "Via Archive", "Failed")
        throw err
      else
        track('List', "Reopen", "Via Archive")
    false

  render: ->
    @$el.html template({
      name: @model.get('name')
      url: @model.getUrl?()
      reOpenText: @options.reOpenText
      canDelete: @canDelete()
      canReopen: @canReopen()
      canLeave: @canLeave()
      deleting: @model.isDeleting?()
    })

    @



// WEBPACK FOOTER //
// ./app/scripts/views/archive/archived-list-view.coffee